<app-section sectionTitle="Shopping List">
  @if (inputItemsGroupedByBuyLocation().length === 0) {
    <p>No items to puchase! Make sure you mark the wanted crafts in the Setup Page!</p>
  }
  @for (entry of inputItemsGroupedByBuyLocation(); track entry[0].name; let groupIndex = $index) {
    <app-subsection [subSectionTitle]="entry[0].displayName + ' (Total Weight: ' + (entry[1].totalWeight | number: '1.0-0') + ' kg)'">
      @for (inputItem of entry[1].items; track inputItem.item.uniqueName; let i = $index) {
        <mat-card style="margin-bottom: 16px">
          <mat-card-content style="padding: 16px">
            <div style="display: flex; align-items: center; gap: 16px">
              <!-- Step Number -->
              <mat-chip-set>
                <mat-chip color="primary" selected>{{ i + 1 }}</mat-chip>
              </mat-chip-set>

              <!-- Item Image -->
              <div style="flex-shrink: 0">
                <app-item-image [item]="inputItem.item" [size]="60" [hideTooltip]="true" />
              </div>

              <!-- Item Details -->
              <div style="flex: 1; min-width: 0">
                <h3 style="margin: 0 0 16px 0; font-weight: 500">
                  {{ inputItem.item.localizedName }}
                </h3>

                <!-- Purchase Info Grid -->
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 16px; margin-bottom: 16px">
                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Quantity</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalAmount() | number: '1.2-2' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Weight</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalWeight() | number: '1.0-0' }} kg</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Buy From</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.buyPriceType()?.friendlyName }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Unit Price</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.buyUserPrice() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Item Cost Before Fees</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalBuyCostWithoutFee() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Leftover Income Before Fees And Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalSellIncomeWithoutFeeOrTax() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Setup Fees</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalBuySetupFeeCost() + inputItem.totalSellSetupFeeCost() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Sales Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalSellTaxesCost() | number: '1.0-0' }}</span>
                  </div>

                  <div>
                    <mat-label style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Result With LeftOvers, Fees and Taxes</mat-label>
                    <span style="font-size: 1.125rem; font-weight: 500">{{ inputItem.totalBuyCostWithFee() - inputItem.totalSellIncomeWithFeeAndTax() | number: '1.0-0' }}</span>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap">
                  <app-copy-text-button [text]="inputItem.item.localizedName"></app-copy-text-button>
                  <app-check-price-button [itemUniqueName]="inputItem.item.uniqueName"></app-check-price-button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </app-subsection>
  }
</app-section>
